export const DEFAULT_CURRENCY = "USD";

const SUPPORTED_CURRENCIES = new Set(["USD", "GTQ", "EUR"]);

const CURRENCY_LOCALES: Record<string, string> = {
  USD: "en-US",
  GTQ: "es-GT",
  EUR: "es-ES",
};

type OrderAmountFields = {
  subtotal?: number | null;
  total_delivery_charge?: number | null;
  tax?: number | null;
  discount?: number | null;
};

export function normalizeCurrency(currency?: string | null): string {
  const code = currency?.trim().toUpperCase();
  if (code && SUPPORTED_CURRENCIES.has(code)) {
    return code;
  }
  return DEFAULT_CURRENCY;
}

function getLocaleForCurrency(currency: string): string {
  return CURRENCY_LOCALES[currency] ?? "en-US";
}

export function calculateOrderTotal(order: OrderAmountFields): number {
  return (
    (order.subtotal ?? 0) +
    (order.total_delivery_charge ?? 0) +
    (order.tax ?? 0) -
    (order.discount ?? 0)
  );
}

export function formatCurrency(
  amount: number,
  currency?: string | null,
  options?: { fractionDigits?: number },
): string {
  const normalizedCurrency = normalizeCurrency(currency);
  const fractionDigits = options?.fractionDigits ?? 2;

  return new Intl.NumberFormat(getLocaleForCurrency(normalizedCurrency), {
    style: "currency",
    currency: normalizedCurrency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}
